import React from 'react';
import RecruiterPerformanceReport from './RecruiterPerformanceReport';
import '../styles/erprecruitment.css';

const PerformanceReportPage = () => {
  return (
    <div className="recruiter-performance-page" style={{ padding: '8px 12px', backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      <RecruiterPerformanceReport />
    </div>
  );
};

export default PerformanceReportPage;
